import React from "react";

/**
 * A magnified view of whatever edge is being dragged.
 *
 * The tool needs more precision than a finger has. A card border is about 3mm
 * on a 63mm card, so on a photo shown 320px wide the whole border is roughly
 * 16px — and a slip of one and a half of those pixels is the difference
 * between a PSA 10 and a 9. Measured on a real photo: 1 screen pixel moves the
 * ratio about 3 points.
 *
 * So the drag is shown at 8x while it happens, with a crosshair on the exact
 * point being placed. The measurement is unchanged — this only magnifies what
 * you are looking at, never what is recorded.
 */

const SIZE = 148;
const ZOOM = 8;

export default function Loupe({ src, at }) {
  if (!at) return null;

  const { x, y, stageW, stageH } = at;
  const bgW = stageW * ZOOM;
  const bgH = stageH * ZOOM;

  /* Follows the pointer to the opposite side, so the thing being looked at is
     never underneath the hand doing the looking. */
  const onLeft = x > 0.5;

  return (
    <div
      className={`cen-loupe${onLeft ? " cen-loupe--left" : ""}`}
      style={{ width: SIZE, height: SIZE }}
      aria-hidden="true"
    >
      <div
        className="cen-loupe-view"
        style={{
          backgroundImage: `url(${src})`,
          backgroundSize: `${bgW}px ${bgH}px`,
          backgroundPosition: `${-(x * bgW - SIZE / 2)}px ${-(y * bgH - SIZE / 2)}px`,
        }}
      />
      <span className="cen-loupe-x" />
      <span className="cen-loupe-y" />
      <span className="cen-loupe-zoom">{ZOOM}×</span>
    </div>
  );
}
